export const FILTER_KEYS = [
  'costCenter',
  'function',
  'employees',
  'planned',
  'types',
  'qualifications',
  'dutyCodes',
  'dutyHourTypes',
  'absences',
  'costCenterOpenRequests',
  'functionOpenRequests',
  'qualificationsOpenRequests',
  'dutyCodesOpenRequests',
  'dutyHourTypesOpenRequests',
  'statusOpenRequests'
] as const;

export type FilterKey = (typeof FILTER_KEYS)[number];

export const EMPTY_ROSTER_PLAN_FILTERS = Object.fromEntries(
  FILTER_KEYS.map((k) => [k, null])
) as Record<FilterKey, null>;
